module.exports = __webpack_public_path__ + "img/hotdog-top-ma004.f949d4a2.jpg";